import './shimmer.css'
const CardShimmer = () => {
    return (
        <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
            <div className="product-cart-wrap mb-30 shimmer-card">
                <div className="product-img-action-wrap">
                    <div className="product-img product-img-zoom shimmer shimmer-img"></div>
                </div>
                <div className="product-content-wrap p-2">
                    <div className="shimmer shimmer-line mb-2 w-100" style={{ height: '16px' }}></div>
                    <div className="shimmer shimmer-line mb-2 w-75" style={{ height: '14px' }}></div>
                    <div className="shimmer shimmer-line mb-2 w-50" style={{ height: '14px' }}></div>
                    <div className="shimmer shimmer-line mb-2 w-100" style={{ height: '18px' }}></div>
                    <div className="d-flex justify-content-between mt-3">
                        <div className="shimmer shimmer-line w-50" style={{ height: '20px' }}></div>
                        <div className="shimmer shimmer-line w-25" style={{ height: '20px' }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardShimmer;
